import Level from "./Level"
import { PlayerId, PlayerIdBool } from "$types"
import { getAnimation } from "./spritesheet"
import OverlayText from "./OverlayText"
import { playerIcons } from "src/common/Player"

export type ExitCallback = (endGame: EndGame) => void
export default class EndGame extends Level {
  private _winner: PlayerId
  onExit?: ExitCallback

  constructor(params: {
    x: number,
    y: number,
    levelData: string,
    activePlayers: PlayerIdBool,
    connectedPlayers: PlayerIdBool,
    winner: PlayerId,
    onExit?: ExitCallback
  }) {
    super({
      x: params.x,
      y: params.y,
      levelData: params.levelData,
      activePlayers: params.activePlayers,
      connectedPlayers: params.connectedPlayers,
    })

    this.onExit = params.onExit
    this._winner = params.winner

    Object.values(this.players).forEach((player) => {
      if (!player) return
      player.movementEnabled = false
      if (player.playerId !== this._winner) {
        player.textures = getAnimation(`player${player.playerId}Stunned`)
        player.loop = true
        player.play()
      }
    })
  }

  onFadeInComplete(): void {
    super.onFadeInComplete()
    window.startFireworks()
    new OverlayText({
      text: `${playerIcons[this._winner].toUpperCase()} player wins the game!`,
      duration: 10000,
      container: this,
      type: "top",
    }).onRemove = () => {
      this.fadeOut()
    }
  }

  onFadeOutComplete(): void {
    if (this.onExit) this.onExit(this)
  }
}
